import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-y-auto flex items-center justify-center"
}
const _hoisted_2 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center" }
const _hoisted_3 = {
  class: "bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-5xl sm:w-full max-h-[90vh] flex flex-col",
  style: {"min-width":"1000px"}
}
const _hoisted_4 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 overflow-y-auto" }
const _hoisted_5 = { class: "flex justify-between items-start" }
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = { style: {"height":"500px"} }
const _hoisted_8 = { class: "bg-gray-50 px-4 py-3 sm:px-6 flex justify-end sticky bottom-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KendoSpreadsheet = _resolveComponent("KendoSpreadsheet")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fixed inset-0 transition-opacity",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
          ])),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                  _createElementVNode("h3", { class: "text-xl font-bold text-gray-900" }, " Review Forecasting Data "),
                  _createElementVNode("p", { class: "text-sm text-gray-500 mt-1" }, "Review and edit the forecast data")
                ], -1)),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                  class: "text-gray-400 hover:text-gray-500"
                }, _cache[5] || (_cache[5] = [
                  _createElementVNode("svg", {
                    class: "h-6 w-6",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ]),
              _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"mt-4 bg-white border border-gray-200 rounded-lg shadow-sm p-4\" data-v-0c49a454><div class=\"grid grid-cols-2 gap-4 mb-4\" data-v-0c49a454><div data-v-0c49a454><h4 class=\"text-sm font-medium text-gray-700\" data-v-0c49a454>Assignee</h4><div class=\"flex items-center mt-1\" data-v-0c49a454><div class=\"flex-shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center text-xs font-medium text-blue-800\" data-v-0c49a454> SG </div><span class=\"ml-2 text-sm text-gray-900\" data-v-0c49a454>Sara Golob</span></div></div><div data-v-0c49a454><h4 class=\"text-sm font-medium text-gray-700\" data-v-0c49a454>Due Date</h4><p class=\"mt-1 text-sm text-gray-900\" data-v-0c49a454>17/11/2025</p></div><div data-v-0c49a454><h4 class=\"text-sm font-medium text-gray-700\" data-v-0c49a454>Priority</h4><span class=\"mt-1 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800\" data-v-0c49a454> Medium </span></div><div data-v-0c49a454><h4 class=\"text-sm font-medium text-gray-700\" data-v-0c49a454>Status</h4><p class=\"mt-1 text-sm text-gray-900\" data-v-0c49a454>Adjustment Needed</p></div></div><div data-v-0c49a454><h4 class=\"text-sm font-medium text-gray-700\" data-v-0c49a454>Description</h4><p class=\"mt-1 text-sm text-gray-900\" data-v-0c49a454>Q2 2025 marketing budget report for financial planning.</p></div></div>", 1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_KendoSpreadsheet, { ref: "spreadsheetComponent" }, null, 512)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                class: "mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveAndClose && _ctx.saveAndClose(...args))),
                class: "inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
              }, " Save Changes ")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}